__turbopack_context__.v({
  "back": "stepper-module-scss-module__akJ2BW__back",
  "model": "stepper-module-scss-module__akJ2BW__model",
  "stepper": "stepper-module-scss-module__akJ2BW__stepper",
  "title": "stepper-module-scss-module__akJ2BW__title",
  "wrapper": "stepper-module-scss-module__akJ2BW__wrapper",
  "wrapperStepper": "stepper-module-scss-module__akJ2BW__wrapperStepper",
});
